import './style.css'
import ReactDOM from 'react-dom/client'
import Experience from './Experience'

const root = ReactDOM.createRoot(document.querySelector('#root'))
root.render(
    <>
        {/* <App /> */}
        <Experience />
    </>
)